import { ControllerRenderProps } from "react-hook-form";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppSelect, Option } from "@/components/ui/app-select";

// Aligns with ContentType type
const options: Option[] = [
  { label: "Image", value: "image" },
  { label: "Video", value: "video" },
  { label: "Audio", value: "audio" },
  { label: "Link", value: "link" },
  { label: "Split", value: "split" },
  { label: "PDF", value: "application/pdf" },
  { label: "Dynamic", value: "dynamic/fromTemplate" },
];

export const ContentTypeSelect: React.FC<{
  field: ControllerRenderProps<any>;
}> = ({ field }) => {
  const { t } = useTranslation();

  return (
    <AppSelect
      value={field.value}
      onChange={field.onChange}
      options={options}
      placeholder={t("Content Type")}
      label={t("Content Type")}
    />
  );
};
